// Ported from the Polaris kit: src/product/components/fileKinds.js.
// The label is an i18n key (this app puts every string in en + pt_BR), read by FileAttachment.vue.
// Change the design in the kit first, then re-port.
import {
  Archive16,
  Code16,
  Csv16,
  Doc16,
  Document16,
  Image16,
  Json16,
  Music16,
  Ppt16,
  Txt16,
  Video16,
  Xls16,
  Pdf16,
} from '@carbon/icons-vue';

export const KINDS = {
  pdf: { icon: Pdf16, labelKey: 'POLARIS.FILE_KINDS.PDF', ext: ['pdf'] },
  doc: {
    icon: Doc16,
    labelKey: 'POLARIS.FILE_KINDS.DOC',
    ext: ['doc', 'docx', 'odt', 'rtf', 'pages'],
  },
  xls: {
    icon: Xls16,
    labelKey: 'POLARIS.FILE_KINDS.XLS',
    ext: ['xls', 'xlsx', 'ods', 'numbers'],
  },
  csv: { icon: Csv16, labelKey: 'POLARIS.FILE_KINDS.CSV', ext: ['csv', 'tsv'] },
  ppt: {
    icon: Ppt16,
    labelKey: 'POLARIS.FILE_KINDS.PPT',
    ext: ['ppt', 'pptx', 'key', 'odp'],
  },
  zip: {
    icon: Archive16,
    labelKey: 'POLARIS.FILE_KINDS.ZIP',
    ext: ['zip', 'rar', 'tar', 'gz', '7z', 'tgz'],
  },
  txt: { icon: Txt16, labelKey: 'POLARIS.FILE_KINDS.TXT', ext: ['txt', 'log'] },
  md: {
    icon: Document16,
    labelKey: 'POLARIS.FILE_KINDS.MD',
    ext: ['md', 'markdown'],
  },
  json: {
    icon: Json16,
    labelKey: 'POLARIS.FILE_KINDS.JSON',
    ext: ['json', 'yaml', 'yml', 'xml'],
  },
  code: {
    icon: Code16,
    labelKey: 'POLARIS.FILE_KINDS.CODE',
    ext: ['js', 'ts', 'vue', 'py', 'rb', 'php', 'html', 'css', 'sh', 'sql'],
  },
  image: {
    icon: Image16,
    labelKey: 'POLARIS.FILE_KINDS.IMAGE',
    ext: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'heic'],
  },
  audio: {
    icon: Music16,
    labelKey: 'POLARIS.FILE_KINDS.AUDIO',
    ext: ['mp3', 'm4a', 'wav', 'ogg', 'aac', 'opus'],
  },
  video: {
    icon: Video16,
    labelKey: 'POLARIS.FILE_KINDS.VIDEO',
    ext: ['mp4', 'mov', 'webm', 'avi', 'mkv'],
  },
  other: { icon: Document16, labelKey: 'POLARIS.FILE_KINDS.OTHER', ext: [] },
};
